<template>
  <v-select
    :label="label"
    :items="getSelectItems"
    :hide-details="shouldHideDetails"
    :value="data"
    @change="$emit('change', $event)"
  ></v-select>
</template>

<script>
  import { mapGetters } from 'vuex'

	export default {
		name: 'PreparationTimeInput',

		props: {
      data: {
        type: String,
        required: false,
      },

      hideDetails: {
        type: Boolean,
        required: false,
        default: false
      }
    },

		data () {
			return {
        field: 'preparationTime',
        label: 'Preparation time'
			}
		},

    computed: {
      items() {
        return this.$store.getters['examinations/getPreparationTimeList']
      },
      getSelectItems () {
        return this.items.map(item => {
          return {
            text: item, value: item
          }
        })
      },

      shouldHideDetails () {
        return this.hideDetails
      }
    }
	}
</script>